(() => {
  if (customElements.get('quantity-pricing')) return;
  class QuantityPricing extends HTMLElement {
    connectedCallback() {
      this.cartKnown = true;
      this.cartQuantity = Number(this.dataset.cartQuantity) || 0;
      this.controller?.abort();
      this.controller = new AbortController();
      document.addEventListener('change', event => {
        if (event.target.name === 'quantity' && event.target.form?.id === this.dataset.formId) this.update();
      }, { signal: this.controller.signal });
      this.update();
    }
    update() {
      const input = document.getElementById(this.dataset.formId)?.elements.namedItem('quantity');
      const quantity = input ? Number(input.value) : Number(this.dataset.minimum);
      const valid = this.cartKnown && Number.isInteger(quantity) && quantity > 0 && (!input || input.checkValidity());
      const total = quantity + this.cartQuantity;
      const tiers = [...this.querySelectorAll('[data-volume-tier]')];
      const active = valid ? tiers.filter(row => Number(row.dataset.minimum) <= total).at(-1) : null;
      tiers.forEach(row => row.toggleAttribute('data-current', row === active));
      this.querySelector('[data-volume-current]').hidden = !active;
      const context = this.querySelector('[data-volume-context]');
      context.hidden = !active;
      if (active) {
        this.querySelector('[data-volume-price]').textContent = active.dataset.price;
        context.textContent = context.dataset.template.replace('[count]', String(total)).replace('[cart]', String(this.cartQuantity));
      }
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('quantity-pricing', QuantityPricing);
  let controller;
  document.addEventListener('cart:updated', async event => {
    const components = [...document.querySelectorAll('quantity-pricing')];
    if (!components.length && !document.querySelector('[data-quantity-rule-input]')) return;
    controller?.abort();
    const request = controller = new AbortController();
    components.forEach(component => { component.cartKnown = false; component.update(); });
    try {
      let cart = event.detail?.cart;
      if (!cart) {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { signal: request.signal, cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Cart refresh failed');
        cart = await response.json();
      }
      if (request.signal.aborted || !Array.isArray(cart.items)) return;
      window.TemporiQuantityRules?.applyCart(cart);
      document.querySelectorAll('quantity-pricing').forEach(component => {
        component.cartQuantity = cart.items.filter(item => String(item.variant_id) === component.dataset.variantId).reduce((sum, item) => sum + item.quantity, 0);
        component.cartKnown = true;
        component.update();
      });
    } catch (_) { /* Keep the authoritative tier table, without a stale quantity estimate. */ }
  });
})();
